import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';

/**
 * 씬(카메라 순회 묶음) 추가 / 이름 수정 다이얼로그
 * sceneNo 는 ScenePlay.json 의 No 이며 프리셋 안에서 유일해야 합니다.
 */
const SceneDialog = ({ open, mode, scene, usedSceneNos, onClose, onSave }) => {
  const [sceneNo, setSceneNo] = useState('');
  const [sceneName, setSceneName] = useState('');

  useEffect(() => {
    if (!open) return;
    if (mode === 'edit' && scene) {
      setSceneNo(String(scene.sceneNo));
      setSceneName(scene.sceneName ?? '');
    } else {
      // 사용 중이 아닌 가장 작은 번호를 제안합니다.
      let next = 1;
      while (usedSceneNos.includes(next)) next += 1;
      setSceneNo(String(next));
      setSceneName('');
    }
  }, [open, mode, scene, usedSceneNos]);

  const handleSave = () => {
    const no = Number(sceneNo);
    if (!Number.isInteger(no) || no < 0) {
      alert('씬 번호는 0 이상의 정수여야 합니다.');
      return;
    }
    if (usedSceneNos.includes(no) && !(mode === 'edit' && scene && scene.sceneNo === no)) {
      alert(`씬 번호 ${no} 는 이미 사용 중입니다.`);
      return;
    }
    if (!sceneName.trim()) {
      alert('씬 이름을 입력하세요.');
      return;
    }
    onSave({ sceneNo: no, sceneName: sceneName.trim() });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{mode === 'add' ? '새 씬' : '씬 정보 수정'}</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <TextField
            label="씬 번호 (ScenePlay.json 의 No)"
            value={sceneNo}
            onChange={(e) => setSceneNo(e.target.value.replace(/[^0-9]/g, ''))}
            fullWidth
            autoFocus
          />
          <TextField
            label="씬 이름"
            value={sceneName}
            onChange={(e) => setSceneName(e.target.value)}
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 6, pb: 4 }}>
        <Button onClick={onClose} color="inherit">
          취소
        </Button>
        <Button onClick={handleSave} variant="contained">
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SceneDialog;
